export const ar = {
  languageBtn: "EN",
  deleteAccount: "حذف الحساب",
  deleteConfirmMsg:
    "بمجرد حذف حسابك سيتم حذف جميع بياناتك بالكامل بشكل دائم ولا يمكن استعادتها",
  iAgree: "أنا موافق",
  enterPhoneNumber: "لحذف حسابك، أدخل رقم هاتفك المحمول وسيصلك رمز التحقق",
  phoneRequired: "رقم الهاتف مطلوب",
  phoneInvalid: "برجاء إدخال رقم هاتف صحيح",
  confirm: "تأكيد",
  enterVerificationCode: "أدخل رمز التحقق",
  verificationCodeRequired: "رمز التحقق مطلوب",
  accountDeleted: "تم حذف حسابك",
};
